interface ChallengeDefinition {
    slug?: string;
    url?: string;
    title?: string;
}

export default ({
    title,
    mapUrl,
    challenge = null,
}: {
    title: string;
    mapUrl: string;
    challenge?: ChallengeDefinition;
}) => `
<div class="locations-map_card">
    <div class="challengecard map">
        <div class="challengecard_imagewrapper challengecard_imagewrapper-map w-condition-invisible">
            <img loading="eager" src="" alt="" class="w-dyn-bind-empty" />
        </div>
        <div class="challengecard_body">
            <h2 class="challengecard_headline challengecard_headline-map">
                ${title} 
            </h2>
            ${challenge !== null ? body(challenge) : ''}
            ${(mapUrl && footer(mapUrl)) || ''}
        </div>
    </div>
</div>
`;

const footer = (mapUrl: string) => `
<div class="challengecard_footer challengecard_footer-center">
    <div class="challengecard_footerright">
        <a 
            href="${mapUrl}"
            target="_blank"
             class="mapslink w-inline-block"
         >
            <div>Open in Google Maps</div>
        </a>
    </div>
</div>
`;

const body = (challenge: ChallengeDefinition) => `
<a 
    data-game-challenge-modal="${challenge.slug ?? ''}"
    href="${challenge.url ?? ''}"
    class="challengecard_relatedchallenge w-inline-block"
>
    <div class="relatedchallenge_label">Related Challenge:</div>
    <div class="relatedchallenge">
        <div class="relatedchallenge_text">${challenge.title ?? ''}</div>
    </div>
</a>`;
